<template>
  <div>
    <TitlePage title="Dettaglio Conversazione AI"></TitlePage>

    <v-btn text small class="mb-4" @click="$router.push('/chatbot/')">
      <v-icon left>mdi-arrow-left</v-icon> Torna alla lista
    </v-btn>

    <template v-if="conversation">
      <v-row class="mb-4">
        <v-col cols="12" md="5">
          <div class="caption grey--text text--darken-1">Session ID</div>
          <div class="caption font-weight-medium">{{ conversation.session_id }}</div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="caption grey--text text--darken-1">Data</div>
          <div>{{ formatDate(conversation.created_at) }}</div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center" style="gap:8px">
          <v-chip :color="conversation.resolved ? 'success' : 'warning'" small dark>
            {{ conversation.resolved ? 'Risolto' : 'Non risolto' }}
          </v-chip>
          <v-chip v-if="conversation.fallback_used" color="orange" small dark>
            Assistenza richiesta
          </v-chip>
        </v-col>
      </v-row>

      <v-card class="pa-4 mb-4" outlined>
        <div class="caption grey--text text--darken-1 mb-2">Utente</div>
        <template v-if="conversation.user_id">
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <div class="caption grey--text">Nome</div>
              <div class="body-2">{{ conversation.user_id.name }} {{ conversation.user_id.surname }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <div class="caption grey--text">Email</div>
              <div class="body-2">{{ conversation.user_id.email }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <div class="caption grey--text">Telefono</div>
              <div class="body-2">{{ conversation.user_id.phone || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex align-end">
              <v-btn x-small text color="primary" :to="`/customers/${conversation.user_id._id}`">
                <v-icon left x-small>mdi-account</v-icon> Profilo
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <div v-else class="caption grey--text font-italic">Utente non registrato (sessione anonima)</div>
      </v-card>

      <v-card class="pa-4">
        <div
          v-for="(msg, i) in conversation.messages"
          :key="i"
          class="mb-3 d-flex"
          :class="msg.role === 'user' ? 'justify-end' : 'justify-start'"
        >
          <v-chip
            :color="msg.role === 'user' ? 'primary' : 'grey lighten-3'"
            :dark="msg.role === 'user'"
            label
            style="max-width:75%;height:auto;white-space:normal"
            class="pa-3"
          >
            <div>
              <div class="caption font-weight-bold mb-1">{{ msg.role === 'user' ? 'Utente' : 'Bot' }}</div>
              <div style="white-space:pre-wrap;word-break:break-word">{{ msg.content }}</div>
            </div>
          </v-chip>
        </div>
      </v-card>
    </template>

    <v-progress-circular v-else indeterminate color="primary" class="mt-8 d-block mx-auto"></v-progress-circular>
  </div>
</template>

<script>
import TitlePage from '@/components/utils/TitlePage';
import { mapActions } from 'vuex';

export default {
  name: 'ChatbotShow',
  components: { TitlePage },
  data: () => ({ conversation: null }),
  mounted() { this.load(); },
  methods: {
    ...mapActions({ fetchConversation: 'chatbot/show' }),
    async load() {
      this.conversation = await this.fetchConversation(this.$route.params.id);
    },
    formatDate(d) { return d ? new Date(d).toLocaleString('it-IT') : '—'; }
  }
};
</script>
